import { lazy, Suspense } from 'react'
import Cursor from '../components/Cursor'
import Header from '../components/Header'
import Hero from '../components/Hero'
import Ticker from '../components/Ticker'
import Footer from '../components/Footer'
import WhatsAppFloat from '../components/WhatsAppFloat'

// Aggressively split off-screen components to save Main-Thread execution time
const Services = lazy(() => import('../components/Services'))
const Properties = lazy(() => import('../components/Properties'))
const About = lazy(() => import('../components/About'))
const WhyChooseUs = lazy(() => import('../components/WhyChooseUs'))
const Projects = lazy(() => import('../components/Projects'))
const Testimonials = lazy(() => import('../components/Testimonials'))
const Updates = lazy(() => import('../components/Updates'))
const CTABanner = lazy(() => import('../components/CTABanner'))
const Contact = lazy(() => import('../components/Contact'))

export default function MainSite() {
  return (
    <div className="app-wrapper">
      <Cursor />
      <Header />
      <main>
        <Hero />
        <Ticker />
        <Suspense fallback={null}>
          <Services />
          <Properties />
          <About />
          <WhyChooseUs />
          <Projects />
          <Testimonials />
          <Updates />
          <CTABanner />
          <Contact />
        </Suspense>
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  )
}
